import styled from 'styled-components';
import { Column, media } from '@simplywallst/ui-core';

export const ColumnWithSpacing = styled(Column)`
  margin-bottom: ${({ theme }) => theme.x2spacePx}px;
  ${media.mdUp`
    margin-bottom: 0px;
  `}
`;
